import React from 'react'
import { Link } from 'react-router-dom'

import Button from './button'
import styles from '../component-styles/welcome-rhs.module.scss'
import chrisSupport from '../assets/ChrisFormalCircleGrey.png'
import amazon from '../assets/amazon-voucher.png'
import { calendarBookingLink } from '../core/variables'
import { BetaLabel } from './counter'
import WelcomeFeedback from './welcome-feedback'
// import useLatestFeature from '../hooks/useLatestFeature'

export function WelcomeLatestFeature(): React.ReactElement {
  // TODO: Implement auto-update for latest feature when new Wix site is ready
  // const latestFeature = useLatestFeature()

  return (
    <div className={styles.latestFeaturesContainer}>
      <h2>
        Link shortener
        <BetaLabel className={styles.newPill} title="New" />
      </h2>
      <p className={styles.featureDescription}>
        Increase clickthroughs with memorable, branded short links.{' '}
        <Link
          className={styles.featureLink}
          to={{
            pathname:
              'https://support.uplifter.ai/hc/en-us/articles/4414310727313-Why-when-and-how-to-create-short-links',
          }}
          target="_blank"
        >
          Learn more
        </Link>
      </p>
      <div className={styles.featureImg}>
        <img
          src="https://uplifter.ai/wp-content/uploads/2021/12/shortlink.png"
          alt="latest feature"
        />
      </div>
      <p className={styles.moreFeaturesLink}>
        <Link
          to={{ pathname: 'https://uplifter.ai/features/#features' }}
          target="_blank"
        >
          More latest features
        </Link>
      </p>
    </div>
  )
}

export default function WelcomeRightModule(): React.ReactElement | null {
  return (
    <div className={styles.containerWrapper}>
      <WelcomeLatestFeature />
      <WelcomeFeedback />
      <div className={styles.helpContainer}>
        <div className={styles.helpButtons}>
          <h2>Need Help?</h2>
          <Button href={calendarBookingLink} newTab>
            Book a walkthrough
          </Button>
          <Button
            href="https://support.uplifter.ai/hc/en-us"
            newTab
            type="flatGrey"
          >
            Visit help centre
          </Button>
        </div>
        <div className={styles.helpImage}>
          <img src={chrisSupport} alt="Uplifter support" />
        </div>
      </div>
      <div className={styles.voucherContainer}>
        <div className={styles.voucherText}>
          <h2>Refer a friend</h2>
          <p>Recommend us and earn up to £100 of Amazon vouchers*</p>
          <Button type="voucher" href="https://uplifter.ai/referral/" newTab>
            More info
          </Button>
          <span>*terms and conditions apply</span>
        </div>
        <img src={amazon} alt="Amazon voucher" className={styles.amazon} />
      </div>
    </div>
  )
}
